import { useState } from "react";

import { Button } from "./Button";

interface Props {
  username: string;
  copiedText?: string;
  className?: string;
  variant?: "default" | "plain";
  children?: React.ReactNode;
}

export function ShareProfileButton({
  username,
  className,
  copiedText = "copied url to clipboard",
  variant = "default",
  children,
}: Props) {
  const [copied, setCopied] = useState(false);

  const shareLink = `${window.location.origin}/${username}`;

  const defaultText = "share your profile";

  const handleShare = async () => {
    if (navigator && navigator.share) {
      try {
        await navigator.share({
          title: "Share your top artists on poke!",
          text: shareLink,
          url: shareLink,
        });
      } catch (error) {
        console.error("Error sharing content:", error);
      }
    } else {
      copyToClipboard(shareLink);
      setCopied(true);
    }
  };

  if (variant === "plain") {
    return (
      <button className={className} onClick={handleShare}>
        {!copied ? children ?? defaultText : copiedText}
      </button>
    );
  }

  return (
    <Button className={className} onClick={handleShare}>
      {!copied ? defaultText : copiedText}
    </Button>
  );
}

function copyToClipboard(text: string) {
  void navigator.clipboard.writeText(text);
}
